import { FC } from "react";
import { UniversalExpanderDataColumn } from "../../UniversalExpanderDataColumn";
import { getPayrollMappings } from "../utils";
import { PayrollEmployment } from "types/landlord/reports";
import { PayrollData } from "../types";

type Props = {
  employment: PayrollEmployment[];
  payroll: PayrollData;
};

export const PayrollIncomeDetails: FC<Props> = ({ employment, payroll }) => {
  return payroll.payroll_income.map((income) => {
    const payrollData = getPayrollMappings(employment, income);

    return (
      <div key={income.account_id} className="flex flex-col gap-3">
        <UniversalExpanderDataColumn
          title="Employment details"
          data={payrollData.payrollEmploymentDetailsMappings}
        />
        <UniversalExpanderDataColumn
          title="Income summary"
          data={payrollData.payrollIncomeSummaryMappings}
        />
        <p className="text-sm font-medium text-content-1000">
          Verified via payroll provider
        </p>
        <div className="border-b border-alpha-100" />
        <p className="text-content-1000 font-medium text-sm">
          {payroll.institution_name}
        </p>
      </div>
    );
  });
};
